import { render, staticRenderFns } from "./proIndex.vue?vue&type=template&id=2b4be2c8&scoped=true&"
import script from "./proIndex.vue?vue&type=script&lang=js&"
export * from "./proIndex.vue?vue&type=script&lang=js&"
import style0 from "./proIndex.vue?vue&type=style&index=0&id=2b4be2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4be2c8",
  null
  
)

export default component.exports